export const EventNamesEnum = {
	TRACING_ID_PROCESSED: 'tracing_id_processed',
};
